import Banner from '@sats-group/ui-lib/react/banner';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import ContentContainer from '../content-container/content-container';
import Logo from '../logo/logo';
import Spinner from '../spinner/spinner';
import type { FlowStatusLayout as Props } from './flow-status-layout.types';

const FlowStatusLayout: React.FunctionComponent<Props> = ({
  logo,
  messages,
  spin,
  text,
  title,
}) => (
  <div className="flow-status-layout">
    <ContentContainer>
      <div className="flow-status-layout__content">
        <header className="flow-status-layout__logo">
          <Logo {...logo} size="small" />
        </header>
        <main className="flow-status-layout__card">
          {title ? (
            <div className="flow-status-layout__title">
              <Text
                elementName="h1"
                italic
                size={Text.sizes.headline2}
                theme={Text.themes.headline}
                tight
              >
                {title}
              </Text>
            </div>
          ) : null}
          {messages.map(entry => (
            <div key={entry.text}>
              <Banner {...entry} />
            </div>
          ))}
          {spin ? (
            <div>
              <Spinner theme={Spinner.themes.centered} />
            </div>
          ) : null}
          {text ? (
            <div className="flow-status-layout__text">
              <Text>{text}</Text>
            </div>
          ) : null}
        </main>
      </div>
    </ContentContainer>
  </div>
);

export default FlowStatusLayout;
